export const GenderData = [
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Female",
    value: "FEMALE",
  },
];

export const schemeTypeData = [
  {
    label: "Public",
    value: "PUBLIC",
  },
  {
    label: "Private",
    value: "PRIVATE",
  },
  {
    label: "Community",
    value: "COMMUNITY",
  },
  {
    label: "Asal",
    value: "ASAL",
  },
];
export const dataTypeData = [
  {
    label: "Production Data",
    value: "PRODUCTION_DATA",
  },
  {
    label: "Farm Input",
    value: "FARM_INPUT",
  }, 
];


export const agencyTypeData = [
  {
    label: "NIA",
    value: "NIA",
  },
  {
    label: "NWHSA",
    value: "NWHSA",
  },
];
export const schemeSizeData = [
  {
    label: "Small",
    value: "Small",
  },
  {
    label: "Medium",
    value: "Medium",
  },
  {
    label: "Large",
    value: "Large",
  },
];
 
export const projStatusData = [
  {
    label: "PLANNED",
    value: "PLANNED",
  },
  {
    label: "ONGOING",
    value: "ONGOING",
  },
  {
    label: "COMPLETED",
    value: "COMPLETED",
  },
];
  
export const compStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "COMPLETED",
    value: "COMPLETED",
  }, 
  {
    label: "STALLED",
    value: "STALLED",
  }, 
];
 
export const paymentStatusData = [
  {
    label: "PENDING PAYMENT",
    value: "PENDING_PAYMENT",
  },
  {
    label: "PAID",
    value: "PAID",
  }, 
];

export const issueStatusData = [
  {
    label: "PENDING",
    value: "PENDING",
  },
  {
    label: "COMPLETED",
    value: "COMPLETED",
  }, 
];

export const damStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "SILTED",
    value: "SILTED",
  }, 
  {
    label: "DECOMMISSIONED",
    value: "DECOMMISSIONED",
  }, 
];

export const boreholeStatusData = [
  {
    label: "COLLAPSED",
    value: "COLLAPSED",
  },
  {
    label: "YIELDING",
    value: "YIELDING",
  }, 
  {
    label: "DRY",
    value: "DRY",
  }, 
  {
    label: "CAPPED",
    value: "CAPPED",
  }, 
];

export const wtrSupplyStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "INACTIVE",
    value: "INACTIVE",
  }, 
   
];

export const FldControlStatusData = [
  {
    label: "FUNCTIONAL",
    value: "FUNCTIONAL",
  },
  {
    label: "DAMAGED",
    value: "DAMAGED",
  }, 
  {
    label: "BREACHED",
    value: "BREACHED",
  }, 
  {
    label: "DRY",
    value: "DRY",
  }, 
  {
    label: "OVERFLOWING",
    value: "OVERFLOWING",
  },  
];
export const rvrTrainingStatusData = [
  {
    label: "COMPLETED",
    value: "COMPLETED",
  },
  {
    label: "DAMAGED",
    value: "DAMAGED",
  }, 
  {
    label: "BREACHED",
    value: "BREACHED",
  }, 
  {
    label: "DRY",
    value: "DRY",
  }, 
  {
    label: "OVERFLOWING",
    value: "OVERFLOWING",
  },  
];

export const plannedProjStatusData = [
  {
    label: "PROPOSAL",
    value: "PROPOSAL",
  },
  {
    label: "CONCEPT",
    value: "CONCEPT",
  }, 
  
];
export const schReclStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  },  
];

export const cropBandStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  },  
];
export const grassBandStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  },  
];

export const negarimBandStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  },  
];
export const treeBandStatusData = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  },  
];

export const panStatusData = [
  {
    label: "OPERATIONAL",
    value: "OPERATIONAL",
  },
  {
    label: "SILTED",
    value: "SILTED",
  },  
  {
    label: "DRY",
    value: "DRY",
  },  
];

export const wtrHarvesters=[
  {
    label: "Boreholes",
    value: "Boreholes",
  },
  {
    label: "Dams",
    value: "Dams",
  },
  {
    label: "Water Pans",
    value: "Water_Pans",
  }, 
]
export const reclamations=[
  {
    label: "Negarims",
    value: "Negarims",
  },
  {
    label: "Schemes",
    value: "Schemes",
  },
  {
    label: "Grass Bands",
    value: "Grass_Bands",
  },
  {
    label: "Crop Bands",
    value: "Crop_Bands",
  },

  {
    label: "Trees Catchment",
    value: "Trees_Catchment",
  }, 
]


export const projMemberType=[
  {
    label: "MANAGER",
    value: "MANAGER",
  },
  {
    label: "RESIDENTIAL_ENGINEER",
    value: "RESIDENTIAL_ENGINEER",
  },
  {
    label: "ASSISTANT_RESIDENTIAL_ENGINEER",
    value: "ASSISTANT_RESIDENTIAL_ENGINEER",
  }, 
  {
    label: "IMPLEMENTATION_COMMITTEE",
    value: "IMPLEMENTATION_COMMITTEE",
  },
  {
    label: "CONTRACTOR_REPRESENTATIVE",
    value: "CONTRACTOR_REPRESENTATIVE",
  }, 
  {
    label: "COMMUNITY_REPRESENTATIVE",
    value: "COMMUNITY_REPRESENTATIVE",
  },
  {
    label: "CLIENT",
    value: "CLIENT",
  },
]

export const schStatusData=[
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DORMANT",
    value: "DORMANT",
  }, 
   {
    label: "UNDER CONSTRUCTION",
    value: "UNDER_CONSTRUCTION",
  },
   {
    label: "STALLED",
    value: "STALLED",
  },
]
export const mtrTypeData=[
  {
    label: "MASTER",
    value: "MASTER",
  },
  {
    label: "INDIVIDUAL",
    value: "INDIVIDUAL",
  }, 
  {
    label: "BOTH",
    value: "BOTH",
  }, 
  {
    label: "NONE",
    value: "NONE",
  }, 
]

export const dynamicTypeData=[
  {
    label: "PDF",
    value: "PDF",
  },
  {
    label: "CSV",
    value: "CSV",
  }, 
 {
    label: "XLSX",
    value: "XLSX",
  }, 
]

export const schemeSetupTypeData=[
  {
    label: "TEXT",
    value: "TEXT",
  }, 
  {
    label: "NUMBER",
    value: "NUMBER",
  }, 
  {
    label: "RADIO",
    value: "RADIO",
  }, 
]

export const schemeSetupCateData=[
  {
    label: "Metrics",
    value: "Metrics",
  }, 
  {
    label: "performance",
    value: "performance",
  },  
]

export const tierData = [
  {
    label: "Tier 1 Expansion",
    value: "Tier 1 Expansion",
  },
  {
    label: "Tier 2 Expansion",
    value: "Tier 2 Expansion",
  },
];

export const financialYearData = Array.from({ length: 10 }, (_, index) => {
  const startYear = new Date().getFullYear() - index;
  return {
    label: `${startYear}/${startYear + 1}`,
    value: `${startYear}/${startYear + 1}`,
  };
});

export const infraStatusData = [
  {
    label: "Fully functional",
    value: "Fully functional",
  },
  {
    label: "Partially functional",
    value: "Partially functional",
  },
  {
    label: "Non functional",
    value: "Non functional",
  },
];

export const mechanizationLevelData = [
  {
    label: "Fully mechanized",
    value: "Fully mechanized",
  },
  {
    label: "Partially mechanized",
    value: "Partially mechanized",
  },
  {
    label: "Manual",
    value: "Manual",
  },
];

export const varietyData = [
  {
    label: "Basmati 370",
    value: "Basmati 370",
  },
  {
    label: "Basmati 217",
    value: "Basmati 217",
  },
  {
    label: "Komboka",
    value: "Komboka",
  },
  {
    label: "BW 196",
    value: "BW 196",
  },
  {
    label: "IR 2793-80-1",
    value: "IR 2793-80-1",
  },
  {
    label: "NERICA",
    value: "NERICA",
  },
  {
    label: "Sindano",
    value: "Sindano",
  },
];

export const fertilizerTypeData = [
  {
    label: "DAP",
    value: "DAP",
  },
  {
    label: "Urea",
    value: "Urea",
  },
  {
    label: "CAN",
    value: "CAN",
  },
  {
    label: "NPK",
    value: "NPK",
  },
  {
    label: "SA (Sulphate of Ammonia)",
    value: "SA (Sulphate of Ammonia)",
  },
  {
    label: "Foliar feed",
    value: "Foliar feed",
  },
  {
    label: "Organic / Manure",
    value: "Organic / Manure",
  },
];

export const mechanizationOperationData = [
  "Land preparation",
  "Transplanting",
  "Weeding",
  "Fertigation and pest control",
  "Harvesting",
];

export const valueAdditionCapacityData = [
  {
    label: "Cosmetics",
    value: "Cosmetics",
  },
  {
    label: "Non alcoholic beverages",
    value: "Non alcoholic beverages",
  },
  {
    label: "Briquettes",
    value: "Briquettes",
  },
  {
    label: "Alcoholic beverages",
    value: "Alcoholic beverages",
  },
  {
    label: "Animal feeds",
    value: "Animal feeds",
  },
  {
    label: "Milling",
    value: "Milling",
  },
   {
    label: "By-produts e.g. hay, husk",
    value: "byproducts",
  },
];

export const seasonData = [
  {
    label: "1st Season",
    value: "1st Season",
  },
  {
    label: "2nd Season",
    value: "2nd Season",
  },
  {
    label: "3rd Season",
    value: "3rd Season",
  },
  {
    label: "1st Ratoon",
    value: "1st Ratoon",
  },
  {
    label: "2nd Ratoon",
    value: "2nd Ratoon",
  },
  {
    label: "3rd Ratoon",
    value: "3rd Ratoon",
  },
];

export const marketChannelData = [
  "Brokers",
  "Government",
  "Local market",
  "Cooperatives",
  "Export",
];

export const pestDiseaseData = [
  "Rice blast",
  "Stem borers",
  "Birds",
  "Rice yellow mottle virus",
  "Bacterial leaf blight",
  "Weeds",
  "Rodents",
];

export const extensionServiceData = [
  {
    label: "Agronomy advisory",
    value: "Agronomy advisory",
  },
  {
    label: "Farmer training",
    value: "Farmer training",
  },
  {
    label: "Market linkages",
    value: "Market linkages",
  },
  {
    label: "Pest and disease management",
    value: "Pest and disease management",
  },
  {
    label: "Soil testing and fertility advisory",
    value: "Soil testing and fertility advisory",
  },
  {
    label: "Water management and irrigation scheduling",
    value: "Water management and irrigation scheduling",
  },
  {
    label: "Seed and input advisory",
    value: "Seed and input advisory",
  },
  {
    label: "Post harvest handling",
    value: "Post harvest handling",
  },
  {
    label: "Mechanization advisory",
    value: "Mechanization advisory",
  },
  {
    label: "Farm business and record keeping",
    value: "Farm business and record keeping",
  },
];